import React from 'react';

const WarningIcon = ({ width = 36, height = 36, fill = '#ff6b6b', ...props }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M18 2L32.6606 30H3.33937L18 2Z"
            stroke={fill}
            strokeWidth="2"
            fill="none"
        />
        <path
            d="M18 12V20"
            stroke={fill}
            strokeWidth="2"
            strokeLinecap="round"
        />
        <circle
            cx="18"
            cy="25"
            r="1.5"
            fill={fill}
        />
    </svg>
);

export default WarningIcon; 